import { ReactEditor } from 'slate-react';
import { Range } from 'slate';
import { notEmpty } from 'utils';

export type GetSlateRangeByAnnotationId = (
  annotationId: string,
) => Range | null;

export default function getSlateRangeByAnnotationId(
  editor,
): GetSlateRangeByAnnotationId {
  return function (annotationId: string): any | null {
    try {
      if (annotationId && notEmpty(editor.children)) {
        const node = editor.findNode(
          (node) => node.annotationId === annotationId,
        );

        if (node) {
          return ReactEditor.findPath(editor, node);
        }

        return null;
      }
    } catch {
      const domNode = document.getElementById(annotationId);

      if (domNode) {
        const domRange = document.createRange();

        domRange.setStart(domNode, 0);

        domRange.setEnd(domNode, 0);

        return ReactEditor.toSlateRange(editor, domRange, {
          exactMatch: false,
        });
      }

      return null;
    }
  };
}
